<template>
  <el-dialog
    title="白名单"
    :visible.sync="WirthMDShow"
    width="80%"
    :close-on-click-modal="false"
    center
  >
    <div class="whitelist-content">
      <!-- 新增按钮和提示 -->
      <div class="header-section">
        <el-button
          type="primary"
          size="small"
          @click="handleAdd"
          style="margin-bottom: 15px"
        >
          新增
        </el-button>
        <div class="tip-text">
          <span style="color: #ff6b35">温馨提示：</span>
          <span style="color: var(--text-muted)">所填手机号需为微信小程序授权手机号。</span>
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        :data="currentPageData"
        border
        style="width: 100%; margin-bottom: 20px"
        :height="400"
      >
        <el-table-column prop="index" label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="name" label="姓名" align="center">
        </el-table-column>

        <el-table-column prop="phone" label="电话" align="center">
        </el-table-column>

        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: var(--accent)"
              @click="handleDelete(scope.row, scope.$index)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="prev, pager, next, sizes, total"
        :total="totalCount"
        style="text-align: center"
      >
      </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      title="添加白名单"
      :visible.sync="addDialogVisible"
      width="450px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addForm"
        label-width="80px"
      >
        <el-form-item label="选择员工" prop="userId">
          <el-select
            v-model="addForm.userId"
            placeholder="请选择员工"
            style="width: 100%"
            filterable
            clearable
            @change="handleEmployeeChange"
            @clear="handleEmployeeClear"
          >
            <el-option
              v-for="item in employeeList"
              :key="item.id"
              :label="`${item.name} (${item.phone})`"
              :value="item.id"
            >
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ item.phone }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 显示选中的员工信息 -->
        <el-form-item label="姓名" v-if="addForm.name">
          <el-input
            v-model="addForm.name"
            disabled
            style="background: var(--card-bg)"
          ></el-input>
        </el-form-item>

        <el-form-item label="手机号" v-if="addForm.phone">
          <el-input
            v-model="addForm.phone"
            disabled
            style="background: var(--card-bg)"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAdd">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSave"
          :disabled="!addForm.userId"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      WirthMDShow: false,
      addDialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,

      // 表格数据
      tableData: [],

      // 员工列表数据
      employeeList: [],

      // 新增表单
      addForm: {
        userId: null,
        name: "",
        phone: "",
      },

      // 表单验证规则
      addFormRules: {
        userId: [{ required: true, message: "请选择员工", trigger: "change" }],
      },
    };
  },

  computed: {
    // 当前页数据
    currentPageData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.tableData.slice(start, end);
    },
  },

  watch: {
    tableData: {
      handler(newVal) {
        this.totalCount = newVal.length;
      },
      immediate: true,
    },
  },

  methods: {
    // 打开弹窗
    openDialog() {
      this.WirthMDShow = true;
      this.getTableData();
    },

    // 获取表格数据
    getTableData() {
      this.$api.marketing
        .white_list()
        .then((res) => {
          console.log(res, "白名单列表");
          this.tableData = res.data.rows || [];
          this.totalCount = res.data.total || 0;
        })
        .catch((error) => {
          console.error("获取白名单列表失败:", error);
          this.$message.error("获取白名单列表失败");
        });
    },

    // 获取员工列表
    getEmployeeList() {
      this.$api.marketing
        .white_userpullList()
        .then((res) => {
          console.log(res, "员工列表");
          // 根据你提供的数据结构，应该是 res.data 或者直接 res
          this.employeeList = res.data.list || res || [];
        })
        .catch((error) => {
          // console.error("获取员工列表失败:", error);
          this.$message.error("获取员工列表失败");
        });
    },

    // 新增
    handleAdd() {
      this.resetAddForm();
      this.addDialogVisible = true;
      // 获取员工列表
      this.getEmployeeList();
    },

    // 重置表单
    resetAddForm() {
      this.addForm = {
        userId: null,
        name: "",
        phone: "",
      };
      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.clearValidate();
        }
      });
    },

    // 员工选择改变事件
    handleEmployeeChange(userId) {
      console.log("选择的员工ID:", userId);
      const selectedEmployee = this.employeeList.find(
        (item) => item.id === userId
      );
      if (selectedEmployee) {
        this.addForm.name = selectedEmployee.name;
        this.addForm.phone = selectedEmployee.phone;
        this.addForm.companyId = selectedEmployee.companyId;
        console.log("选中员工信息:", selectedEmployee);

        // 手动触发表单验证
        this.$nextTick(() => {
          if (this.$refs.addForm) {
            this.$refs.addForm.validateField("userId");
          }
        });
      } else {
        this.addForm.name = "";
        this.addForm.phone = "";
      }
    },

    // 清空选择
    handleEmployeeClear() {
      this.addForm.name = "";
      this.addForm.phone = "";
    },

    // 取消添加
    cancelAdd() {
      this.addDialogVisible = false;
      this.resetAddForm();
    },

    // 保存
    handleSave() {
      
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          console.log("提交的数据:", {
            name: this.addForm.name,
            phone: this.addForm.phone,
            userId: this.addForm.userId,
            companyId:this.addForm.companyId
          });

          this.$api.marketing
            .white_add({
              name: this.addForm.name,
              phone: this.addForm.phone,
              userId: this.addForm.userId,
              companyId:this.addForm.companyId
            })
            .then((res) => {
              if(res.code==200){
                this.$message.success("添加成功");
                this.addDialogVisible = false;
                this.getTableData();
                
                this.resetAddForm();
              }
              
            })
            .catch((error) => {
              console.error("添加失败:", error);
              this.$message.error("添加失败，请重试");
            });
        } else {
          console.log("表单验证失败");
        }
      });
    },

    // 删除
    handleDelete(row, index) {
      this.$confirm("确定要删除这名员工吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 这里调用删除接口
          // 假设有删除接口，使用 row.id 或其他唯一标识
          this.$api.marketing
            .white_delete({ id: row.id })
            .then(() => {
              this.getTableData();
              this.$message.success("删除成功");
            })
            .catch((error) => {
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          console.log("取消删除");
        });
    },

    // 分页大小改变
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
    },

    // 当前页改变
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
    },
  },
};
</script>

<style scoped>
.whitelist-content {
  padding: 0 10px;
}

.header-section {
  margin-bottom: 20px;
}

.tip-text {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.5;
}

/* 表格样式调整 */
::v-deep .el-table th {
  background: var(--card-bg);
  font-weight: 600;
}

::v-deep .el-table td {
  padding: 8px 0;
}

/* 分页样式 */
::v-deep .el-pagination {
  margin-top: 20px;
}

/* 弹窗内容样式 */
.dialog-footer {
  text-align: right;
}

/* 下拉选项样式 */
::v-deep .el-select-dropdown__item {
  height: auto;
  line-height: 1.5;
  padding: 8px 20px;
}

/* 禁用输入框样式 */
::v-deep .el-input.is-disabled .el-input__inner {
  background: var(--card-bg);
  border-color: #e4e7ed;
  color: var(--text-sub);
}
</style>
